import { fromJS } from 'immutable'

export default fromJS({
  questions: {
    noAlt: 'Teks alternatif untuk gambar ini tidak tersedia',
    noAnswers: 'Tidak ada pilihan jawaban, silakan klik berikutnya untuk melanjutkan.',
    placeholder: 'Mohon sebutkan…',
    pleaseSelect: 'Mohon pilih…',
    rotateLandscape: 'Matikan Kunci Orientasi pada ponsel Anda dan putar ke lanskap untuk melanjutkan.',
    rotatePortrait: 'Putar ponsel Anda dari lanskap ke potret untuk melanjutkan.',
    ir: {
      selectWebCam: "Pilih webcam (jika tersedia) atau klik 'Cari' untuk mengunggah dari perangkat Anda",
      noWebCam: 'Tidak ada webcam terdeteksi',
      accessCamUpload: 'AKSES KAMERA/UNGGAH',
      browse: 'CARI',
      uploadPhoto: 'Unggah foto',
      instead: 'sebaliknya',
      capture: 'AMBIL FOTO',
      somethingWrong: 'Maaf, terjadi kesalahan. Silakan coba lagi nanti.',
      couldntRead: 'Maaf, kode tidak dapat dibaca!',
      couldntProcess: 'Maaf, gambar tidak dapat diproses!',
      moveOn: 'Silakan coba lagi atau kirim foto Anda dan lanjutkan',
      tryAgain: 'Silakan coba lagi',
      dataReceived: 'Data diterima!',
      enterManually: 'Silakan coba lagi atau masukkan data secara manual di bawah ini',
      positionQR:
        'Posisikan kode QR di depan kamera untuk memuatnya di dalam bingkai merah atau unggah dari komputer Anda.',
      analyzing: 'Menganalisis gambar, mohon tunggu',
      submit: 'KIRIM',
      startOver: 'Rekam ulang',
      allDone: 'Selesai!',
      cantAnalyze:
        'Perhatian - kami tidak dapat menggabungkan gambar ini. Cobalah untuk mengirim ulang atau pilih format gambar yang lebih umum (JPG, PNG, GIF, BMP)',
      wrongFormat:
        'Maaf - kami tidak mendukung format fail ini. Unggah tipe gambar yang didukung (JPG, PNG, GIF, BMP, TIF, PDF, SVG)'
    },
    vr: {
      noWebCam: 'Tidak ada webcam terdeteksi',
      uploadVideo: 'Unggah video',
      skip: 'Lewati?',
      accessCamUpload: 'AKSES KAMERA/UNGGAH',
      browse: 'CARI',
      instead: 'sebaliknya',
      or: 'atau',
      stopRecording: 'Berhenti merekam',
      willBeStopped: 'Perekaman akan berhenti setelah 5 menit',
      stopOnDone: 'Berhentilah merekam saat Anda selesai!',
      record: 'REKAM',
      somethingWrong: 'Maaf, terjadi kesalahan. Silakan coba lagi nanti.',
      microphone: 'Mikropon',
      camera: 'Kamera Web',
      selectMicrophone: 'Pilih mikrofon Anda',
      selectCam: 'Pilih kamera web Anda',
      upload: 'Unggah',
      playback: 'Pemutaran',
      stopPlayback: 'BERHENTI',
      submit: 'KIRIM',
      startOver: 'Rekam ulang',
      allDone: 'Selesai!',
      alternativeRecordSpan: 'Mohon unggah klip video dari komputer<br/>Anda,  &nbsp;',
      alrenativeRecordHref: ' atau Anda dapat merekam video dengan kamera web.',
      cantAnalyze:
        'Perhatian - kami tidak dapat menggabungkan video ini. Cobalah untuk mengirim ulang atau pilih format video yang lebih umum (MP4, M4V, WEBPM)',
      wrongFormat:
        'Maaf - kami tidak mendukung format fail ini. Unggah tipe video yang didukung (MP4, AVI, M4V, WEBPM, MOV, MKV, MPG, WMV)'
    },
    cjc: {
      choose: 'PILIH',
      pleaseChoose: 'Silakan pilih',
      this: 'Yang',
      one: 'INI',
      myChoice: 'PILIHAN Saya'
    },
    hm: {
      addComment: 'Silakan tambahkan komentar di bawah ini',
      commentMandatoryPlaceHolder: 'Silakan tambahkan komentar wajib... ',
      commentOptionalPlaceHolder: 'Silakan tambahkan komentar opsional... ',
      dragPin: 'Seret untuk memposisikan ulang (klik lama/ketuk untuk pemberian pin presisi).',
      removePin: 'Seret ke luar gambar untuk menghapus.',
      editComment: 'Klik/ketuk pin untuk mengedit komentar.',
      addPin: 'Seret pin dari panel di bawah ini dan letakkan di tempat pilihan Anda pada gambar.',
      addPins: 'Seret pin dari panel di bawah ini dan letakkan di tempat pilihan Anda pada gambar.',
      leavePins: (minPoints, maxPoints) =>
        `Silakan tinggalkan setidaknya ${minPoints} tetapi tidak lebih dari ${maxPoints} pin dari semua jenis.`,
      leavePinsPerPage: (minPoints, maxPoints) =>
        `Silakan tinggalkan setidaknya ${minPoints} tetapi tidak lebih dari ${maxPoints} pin.`,
      leavePinsWithOff: maxPoints =>
        `Silakan tinggalkan tidak lebih dari ${maxPoints} pin dari segala jenis atau klik Berikutnya untuk melewati.`,
      leavePinsPerPageWithOff: maxPoints =>
        `Silakan tinggalkan tidak lebih dari ${maxPoints} pin atau klik Berikutnya untuk melewati.`,
      leavePinWithOff:
        'Silakan tinggalkan tidak lebih dari 1 pin dari setiap jenis atau klik Berikutnya untuk melewati.',
      leavePinPerPageWithOff: 'Silakan tinggalkan tidak lebih dari 1 pin atau klik Berikutnya untuk melewati.',
      leaveExactlyPin: 'Silakan tinggalkan 1 pin dari setiap jenis.',
      leaveExactlyPinPerPage: 'Silakan tinggalkan 1 pin.',
      leaveExactlyPins: maxPoints => `Silakan tinggalkan ${maxPoints} pin dari segala jenis.`,
      leaveExactlyPinsPerPage: maxPoints => `Silakan tinggalkan ${maxPoints} pin.`,
      leaveComment: 'Ketik di bawah gambar untuk meninggalkan komentar.',
      noAnswers: 'Tidak ada pilihan jawaban, silakan klik selanjutnya untuk melanjutkan.',
      outOfPins: 'Anda kehabisan pin',
      pinsBehavior: 'Saat bergerak melewati gambar, Anda akan melihat area yang akan disorot dengan satu pin drop.',
      clusters: 'Anda hanya bisa menempatkan pin pada area yang disorot.',
      contentAware: 'Anda bisa menjatuhkan pin di dalam atau di luar area yang disorot.'
    },
    mp: {
      expand_note: 'Arahkan kursor atau klik pada gambar untuk memperbesar',
      rb_note: rows => `Silakan pilih hanya 1 tanggapan per item${rows ? ' di bawah ini' : ''}:`,
      cb_note: (min, max, rows) => {
        if (1 === min && 5000 === max) {
          return 'Pilih semua yang berlaku:'
        } else if (min === max) {
          return `Silakan pilih ${1 !== min ? 'setiap' : 'hanya'} ${min} tanggapan per item${
            rows ? ' di bawah ini' : ''
          }:`
        } else if (min > 0 && max < 5000) {
          return `Pilih minimal ${min} tanggapan dan maksimal ${max} per item${rows ? ' di bawah ini' : ''}:`
        } else if (5000 === max && min > 0) {
          return `Pilih minimal ${min} tanggapan per item${rows ? ' di bawah ini' : ''}:`
        } else if (0 === min && max < 5000) {
          return `Pilih maksimal ${max} tanggapan per item${rows ? ' di bawah ini' : ''}:`
        } else {
          return 'Pilih semua yang berlaku:'
        }
      }
    },
    sh: {
      note: 'Klik produk untuk memperbesar dan menambahkan ke keranjang virtual jika Anda akan membelinya di toko',
      amazonNote: 'Klik produk untuk memperbesar dan menambahkan ke keranjang virtual Anda.',
      fullCart: 'Keranjang Anda penuh!',
      qty: 'JUMLAH',
      addToCart: 'MASUKKAN KE KERANJANG',
      each: 'setiap',
      items: 'item',
      deleteFromCart: 'HAPUS',
      emptyCard: 'Keranjang Anda kosong',
      total: 'Keranjang',
      clearCart: 'Kosongkan keranjang',
      backToStore: 'Kembali ke toko',
      next: 'BERIKUT',
      na: 'Tidak satu pun dari yang di atas',
      maxCartCountError: max => `Tambahkan maksimal ${max} produk ke keranjang Anda`,
      scrollError: `Gulir sepenuhnya ke kiri dan kanan untuk melanjutkan survei. `,
      maxSpentError: max => `Lakukan pembelanjaan maksimal ${max}.`,
      maxProductCountError: max => `Tambahkan maksimal ${max} kuota ke keranjang Anda untuk setiap produk.`
    },
    rb: {
      note: 'Silahkan pilih hanya 1 item:'
    },
    vo: {
      note: 'Silakan tonton videonya sampai akhir'
    },
    cb: {
      note: (min, max) => {
        if (min === max) {
          return `Mohon pilih ${min} item ${1 !== min ? 'yang mana saja' : 'saja'}:`
        } else if (min > 0 && max < 5000) {
          return `Mohon pilih paling tidak ${min} item tetapi tidak lebih dari ${max}:`
        } else if (5000 === max && min > 0) {
          return `Mohon pilih paling tidak ${min} item:`
        } else if (0 === min && max < 5000) {
          return `Mohon pilih tidak lebih dari ${max} item:`
        } else {
          return 'Pilih semua yang berlaku:'
        }
      }
    },
    oe: {
      na: 'Tak dapat diterapkan',
      note: (min, max, optional) => {
        if (min === max) {
          return `Mohon ketikkan ${min} karakter ${1 !== min ? 'yang mana saja' : 'saja'}${
            optional ? ' (opsional)' : ''
          }:`
        } else if (min > 0 && max < 5000) {
          return `Mohon ketikkan paling tidak ${min} karakter tetapi tidak lebih dari ${max}${
            optional ? ' (opsional)' : ''
          }:`
        } else if (5000 === max && min > 0) {
          return `Mohon ketikkan paling tidak ${min} karakter${optional ? ' (opsional)' : ''}:`
        } else if (0 === min && max < 5000) {
          return `Mohon ketikkan tidak lebih dari ${max}${optional ? ' (opsional)' : ''}:`
        } else {
          return ''
        }
      }
    },
    oex: {
      note: 'Silakan isi kolom-kolom berikut ini:'
    },
    mx: {
      note: 'Gerakkan slider yang disoroti untuk melanjutkan',
      dragSlider: 'Tarik ke kiri atau kanan untuk menjawab'
    },
    psc: {
      dragLeftRight: 'Tarik ke kiri atau kanan untuk menjawab'
    },
    ps: {
      note: value => `Mohon distribusikan  ${value} yang tersisa di antara item-item di bawah ini`,
      allDone: 'Selesai!',
      total: `Total:`,
      dragSlider: 'Tarik ke kiri atau kanan untuk menjawab'
    },
    cx: {
      note: 'Buka dropbox dan mulailah ketikkan jawaban Anda untuk bergulir otomatis atau pilih secara manual.'
    },
    ro: {
      note: 'Tarik ke atas atau ke bawah untuk mengubah urutannya:'
    },
    md: {
      note1: 'Silakan klik/ketuk item pilihan pertama Anda<br/>Klik/ketuk lagi untuk menghapus pilihan.',
      note2: 'Sekarang silakan klik/ketuk item pilihan terakhir Anda<br/>Klik/ketuk lagi untuk menghapus pilihan.',
      note3:
        'Terima kasih! Lanjutkan ke pertanyaan berikutnya<br/>atau klik/ketuk item yang tidak dipilih untuk memulai kembali.'
    },
    aro: {
      note: 'Silakan pilih satu item untuk setiap pasang.'
    },
    wd: {
      note: 'Pastikan setiap nilai yang berikutnya lebih besar dari nilai yang sebelumnya.'
    },
    emd: {
      note: 'Silakan tonton videonya sampai akhir',
      noAnswers: 'Tidak ada pilihan jawaban, silakan klik berikutnya untuk melanjutkan.',
      start: 'Klik dan tahan untuk memulai',
      resume: 'Klik dan tahan untuk melanjutkan',
      continue: 'Anda sudah siap! <br />Klik berikutnya untuk melanjutkan',
      continueMobile: 'Anda siap! <br /> Klik DI SINI untuk melanjutkan',
      training: {
        session: 'sesi Pelatihan',
        note: 'Selesaikan pelatihan',
        moveLeft: 'Seret tombol ke kiri',
        moveBottom: 'Seret tombol ke bawah',
        moveRight: 'Sekarang, seret tombol ke kanan',
        moveTop: 'Sekarang, seret tombol ke atas',
        success: 'Kerja bagus!'
      }
    },
    sft: {
      noAnswers: 'Tidak ada pilihan jawaban, silakan klik berikutnya untuk melanjutkan.',
      note: 'Jawab secepat mungkin dengan jawaban yang secara intuitif dianggap benar',
      finish: 'Anda sudah selesai! <br /> Klik Berikutnya untuk melanjutkan',
      training: {
        start:
          '<p>Pertanyaan ini akan menunjukkan kata-kata yang berbeda secara cepat dan membutuhkan konsentrasi Anda. ' +
          'Anda harus bereaksi secepat mungkin untuk menjawabnya. </p> <p>Siap berlatih?</p>',
        step1: (touch, mouse, key) =>
          touch
            ? `Ketuk "{buttonLeft}"`
            : (mouse ? `Klik "{buttonLeft}"` : '') +
              (key && mouse ? ' / ' : '') +
              (key ? `Tekan tombol "{keyBtnLeft}"` : ''),
        step2: (touch, mouse, key) =>
          touch
            ? `Ketuk "{buttonRight}"`
            : (mouse ? `Klik "{buttonRight}"` : '') +
              (key && mouse ? ' / ' : '') +
              (key ? `Tekan tombol "{keyBtnRight}"` : ''),
        fail: () => 'Terlalu lambat',
        success: () => 'Bagus!',
        finish: () =>
          '<p><strong> Luar biasa!</strong></p><p>Pastikan Anda tidak akan terganggu dalam 2-3 menit ke depan<br />' +
          'dalam 2-3 menit ke depan</p><p>Klik Berikutnya untuk memulai jika sudah siap.</p>'
      },
      buttons: {
        start: 'Mulai',
        yesno: {
          left: 'Ya',
          right: 'Tidak'
        },
        matches: {
          left: 'Cocok',
          right: 'Tidak Cocok'
        },
        fits: {
          left: 'Pas',
          right: 'Tidak Pas'
        },
        thumbs: {
          left: '<i class="rfd-ui-button-icon icon-aytmfd-thumbsUp"></i>',
          right: '<i class="rfd-ui-button-icon icon-aytmfd-thumbsDown"></i>'
        }
      }
    }
  }
})
